export default __webpack_public_path__ + "locales/it/ConnectDialog.json?hash=e990aaa5c6edb0cd61574b49a344d5e3";